var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interfaceConfig"},[_c('slider',{on:{"load-data":_vm.handleLoadData}}),_c('tableList',{attrs:{"directory-id":_vm.selectId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }